import React from 'react';
import { colors } from '../../colors';

const PrivacyPolicy = () => {
  return (
    <div style={{ color: colors.white, padding: 24 }}>
      <h1 style={{ margin: 0 }}>
        {' '}
        Privacy Policy for Automagically Email Service
      </h1>

      <p style={{ margin: 0, color: colors.gray, marginTop: -8 }}>
        Last Updated: May 21, 2025
      </p>

      <p>
        Automagically Email Service, accessible at
        https://automagically.be/email, enables automated email sending to our
        users. This Privacy Policy explains how we handle data in connection
        with our use of Google’s Gmail API.
      </p>

      <h3 style={{ margin: 0, marginBottom: -16 }}>1. Data We Collect</h3>
      <p>
        We use a single, centrally managed Google account to authenticate with
        the Gmail API using the scope
        &quot;https://www.googleapis.com/auth/gmail.send&quot;. This allows our
        service to send emails on behalf of the central account. We collect:
      </p>
      <ul style={{ marginTop: -16 }}>
        <li>
          The email address of the central Google account used for
          authentication.
        </li>
        <li>No Google account data is collected from users of our service.</li>
      </ul>

      <h3 style={{ margin: 0, marginBottom: -16 }}>2. How We Use Data</h3>
      <p> The data from the central Google account is used solely to:</p>
      <ul style={{ marginTop: -16 }}>
        <li>
          Authenticate with the Gmail API to send emails on behalf of the
          website.
        </li>
      </ul>
      <p>
        We do not collect or process any Google account data from our users.
      </p>

      <h3 style={{ margin: 0, marginBottom: -16 }}>3. Data Sharing</h3>
      <p>
        We do not share, transfer, or disclose the central account’s data with
        third parties, except as required to interact with Google’s Gmail API to
        provide the service.
      </p>

      <h3 style={{ margin: 0, marginBottom: -16 }}>
        4. Data Storage and Security
      </h3>
      <p>
        The central account’s OAuth tokens are stored securely and encrypted to
        protect the account’s information. We retain these tokens only as long
        as necessary to provide the email-sending service.
      </p>

      <h3 style={{ margin: 0, marginBottom: -16 }}>5. Revoking Access</h3>
      <p>
        The owner of the central Google account can revoke our app’s access at
        any time via their Google Account settings
        (https://myaccount.google.com/permissions).
      </p>

      <h3 style={{ margin: 0, marginBottom: -16 }}>6. Contact Us</h3>
      <p>
        For questions about this Privacy Policy, contact us at:
        [automagicallly@gmail.com].
      </p>

      <p>
        This Privacy Policy complies with Google’s API Services User Data
        Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
